<template>
  <div class="">
    <van-tabs v-model="activeTab" @click="onClickTab" color="#3083f4">
      <van-tab title="待审核" name="0"></van-tab>
      <van-tab title="已通过" name="1"></van-tab>
      <van-tab title="已驳回" name="2"></van-tab>
    </van-tabs>
    <!-- 搜索框 -->
    <div>
      <van-search show-action v-model="applyTime" placeholder="请选择申请时间" readonly @click="applyTimeShow = true">
        <template #action>
          <div @click="onapplyTimeSearch">清空</div>
        </template>
      </van-search>
    </div>
    <van-calendar
        v-model="applyTimeShow"
        @confirm="applyTimeClick"
        color="#3083f4"
        :min-date="minDate"
        :max-date="maxDate"
    />
    <van-list
        v-model="loading"
        :finished="finished"
        offset="20"
        :immediate-check="false"
        @load="onLoad"
        finished-text="没有更多了 ~"
        v-if="list.length > 0"
    >
      <div style="width: 100%; border-bottom: 1px solid #eaeaeb" v-for="(item, index) in list" :key="index">
        <div class="box">
          <div class="top">
            <div style="flex: 1">
              <img src="../../assets/image/待处理.png" alt=""/>
              <span class="title">{{ item.applyTime }}</span>
            </div>
            <span class="time">
              <span v-if="item.status == 0" style="color: #fbc21f">待审核</span>
              <span v-if="item.status == 1" style="color: #139659">通过</span>
              <span v-if="item.status == 2" style="color: #f04438">驳回</span>
            </span>
          </div>
          <div class="des" style="margin-top: 10px">
            <div class="time" v-if="item.applyUserName != null">申请人：{{ item.applyUserName }}</div>
            <div class="time">补卡原因：{{ item.applyReason }}</div>
            <div class="time" v-if="item.examineUserName != null">审核人：{{ item.examineUserName }}</div>
            <div class="time" v-if="item.examineTime != null">审核时间：{{ item.examineTime }}</div>
            <div class="time" v-if="item.examineRemark != null">审核备注：{{ item.examineRemark }}</div>
          </div>
          <div class="bottom" v-if="item.status == 0">
            <van-button round type="info" style="padding: 0 20px" size="small" @click="repairApply(item.id,index)"
            >审核
            </van-button
            >
          </div>
          <div class="result"></div>
        </div>
      </div>
    </van-list>
    <van-empty description="暂无申请记录" v-if="list.length == 0"/>

    <!-- 补卡申请 -->
    <van-popup v-model="repairDialog" show-cancel-button @close="cancelDialog" position="bottom">
      <div style="margin: 10px" class="repair">
        <h3 style="text-align: center; margin: 10px 0">补卡审核</h3>
        <!-- <van-field v-model="remark" label="补卡时间" readonly /> -->

        <div class="applyReason">
          <div style="padding: 6px 16px; color: #646566; font-size: 14px"><span style="color: red">*</span> 审核</div>
          <div style="padding: 6px 16px; color: #646566; font-size: 14px">
            <van-radio-group v-model="repairForm.status" direction="horizontal">
              <van-radio name="1">通过</van-radio>
              <van-radio name="2">未通过</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div class="applyReason">
          <div style="padding: 2px 16px; color: #646566; font-size: 14px">备注</div>
          <van-field v-model="repairForm.examineRemark" rows="3" autosize type="textarea" placeholder="请输入备注"/>
        </div>
      </div>
      <div style="margin: 10px">
        <van-button round type="info" style="width: 100%" @click="repairConfirm">确认</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {getRepairApplyPage, repairApplyExamine} from '@/api/Industry'
import {Toast} from 'vant'

export default {
  data() {
    return {
      setIndex: 0,
      activeTab: 0,
      hidden: true, //没有更多数据了
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      list: [],
      applyTime: null,
      pageNum: 1,
      applyTimeShow: false,
      minDate: new Date(2023, 0, 1),
      maxDate: new Date(2030, 0, 31),
      repairForm: {
        id: null,
        examineUserId: this.$route.params.userId,
        examineRemark: '',
        status: '',
      },
      repairDialog: false,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 清空申请时间
    onapplyTimeSearch() {
      this.applyTime = null
      this.pageNum = 1
      this.list = []
      this.getList()
    },
    // 选中申请时间
    applyTimeClick(date) {
      this.applyTimeShow = false
      // this.applyTime = this.formatDate(date)
      this.pageNum = 1
      this.list = []
      this.getList()
    },
    formatDate(val) {
      let date = new Date(val)
      return `${date.getFullYear()}-${date.getMonth() + 1 < 10 ? '0' : ''}${date.getMonth() + 1}-${
          date.getDate() < 10 ? '0' : ''
      }${date.getDate()}`
    },
    // tab切换
    onClickTab(e) {
      this.pageNum = 1
      this.list = []
      this.getList()
    },
    // 下拉刷新
    onLoad() {
      this.loading = true
      this.pageNum = this.pageNum + 1
      this.getList()
    },
    getList() {
      getRepairApplyPage({
        // applyUserId: this.$route.params.userId,
        platformId: this.$route.params.platformId,
        companyId: this.$route.params.companyId,
        pageNum: this.pageNum,
        pageSize: 10,
        status: this.activeTab,
        applyDate: this.applyTime,
      }).then((res) => {
        if (res.code == 200) {
          let rows = res.data.list
          this.list = this.list.concat(rows)
          this.loading = false
          if (!res.data.hasNextPage) {
            // 加载结束 => 没有下一页
            console.log('结束')
            this.finished = true
          } else {
            this.finished = false
          }
        }
      })
    },
    // 补卡审核
    repairApply(val, index) {
      this.repairForm.id = val
      this.setIndex = index;
      let num = (this.setIndex + 1) % 10;
      let nums = parseInt((this.setIndex + 1) / 10)
      let pageNum;
      if(num===0){
        pageNum=nums;
      }else{
        pageNum=nums+1;
      }
      this.pageNum = pageNum
      this.repairDialog = true
    },
    // 关闭审核弹窗
    cancelDialog() {
      this.repairDialog = false
      this.repairForm = {
        id: null,
        examineUserId: this.$route.params.userId,
        examineRemark: '',
        status: '',
      }
    },
    // 补卡申请确认
    repairConfirm(e) {
      if (this.repairForm.status == null || this.repairForm.status == '') {
        Toast('请选择审核状态')
        this.repairDialog = true
        return false
      } else {
        repairApplyExamine(this.repairForm).then((res) => {
          if (res.code == 200) {
            //提交审核成功;
            //查询当前页的数据
            //获取当前页


            // let pageNum=(this.setIndex+1)%10==0?(this.setIndex+1)/10:((this.setIndex+1)/10)+1
            // this.pageNum = 1
            // // this.list = []
            // this.getList()
            this.list.splice(this.setIndex, 1)
            //删除指定数据
            Toast.success('已审核')
            this.repairDialog = false
          } else {
            Toast(res.msg)
          }
        })



      }
    },
  },
}
</script>
<style scoped>
/deep/ .van-tab {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #999999;
  border-bottom: 1px solid #eaeaeb;
}

/deep/ .van-tab--active {
  color: #1e1e1e;
  font-weight: bold;
}

/deep/ .van-tabs__line {
  width: 18px;
  height: 3px;
  background: #1e1e1e;
  border-radius: 2px;
  bottom: 20px;
}

/deep/ .van-search {
  padding: 10px 12px 7px;
}

/deep/ .van-search__content {
  background-color: #ededef;
  border-radius: 7px;
  width: 84%;
  flex: none;
}

/deep/ .van-search .van-cell .van-field__left-icon {
  color: #9a9a9a;
}

.box {
  margin: auto;
  width: 92%;
  margin-top: 14px;
}

.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.box img,
.Name {
  width: 22px;
  height: 22px;
  line-height: 22px;
  border-radius: 4px;
  vertical-align: middle;
  margin-right: 7px;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 9px;
  color: #fff;
  box-sizing: border-box;
  text-align: center;
}

.box .title {
  vertical-align: middle;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 16px;
  color: #1e1e1e;
}

.time {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 11px;
  color: #999999;
}

.des .time {
  font-size: 13px;
  line-height: 20px;
}

.result {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #48d25f;
  margin: 6px 0 15px;
}

.bottom {
  text-align: right;
  margin-top: 10px;
}

/deep/ .applyReason .van-cell__value {
  border: 1px solid #dcdfe6 !important;
  padding: 0 5px;
  border-radius: 4px;
}
</style>
